/* eslint-disable react-hooks/exhaustive-deps */
import {useContext, useEffect, useState} from "react"
import {useQuery} from "@tanstack/react-query"
import {head, isEmpty, map} from "lodash"
import {chatServiceV2} from "services"
import {Tabs} from "antd"
import {TabHeader} from "components/Tab"
import {BaseLoading} from "components"
import styles from "./StudentNotePanel.module.css"
import cx from "classnames"
import {UNLIMITED_PAGE_SIZE} from "data/constants"
import {TopicDetails} from "sections/NewCommunication/parts/Notes/part"
import {CommunicationContext} from "context/CommunicationContext"

type Props = {
    user: any
    isSidebarChat?: boolean
}

export function StudentNotePanel(props: Props) {
    const {user, isSidebarChat = false} = props
    const [activeKey, setActiveKey] = useState(null)
    const {changeRoom} = useContext(CommunicationContext)

    const {data: roomId} = useQuery(
        ["student-channel", user.profileId],
        async () => {
            const channelInfo = await chatServiceV2.getStudentChannel({studentProfileId: user.profileId})
            return channelInfo?.roomId
        },
        {enabled: !!user?.profileId}
    )

    const {
        data: topics,
        isLoading: isTopicsLoading,
        isSuccess: isTopicsSuccess
    } = useQuery(
        ["student-channel-topics", roomId],
        async () => {
            const {data} = await chatServiceV2.getChannelTopics({
                filter: {parentRoomId: roomId},
                range: {page: 1, pageSize: UNLIMITED_PAGE_SIZE}
            })
            return data
        },
        {enabled: !!roomId, refetchOnMount: true}
    )

    useEffect(() => {
        if (isTopicsSuccess && !isEmpty(topics)) {
            const generalTopic = head(topics)
            changeRoom(generalTopic)
            setActiveKey(`${generalTopic.roomId}`)
        }
    }, [isTopicsSuccess, topics])

    const onChangeTab = (key: string) => {
        const topic = topics?.find((topic) => topic.roomId === parseInt(key))
        if (topic) {
            changeRoom(topic)
        }
        setActiveKey(key)
    }

    const isOnlyMessageCreation = false

    if (!user) {
        return null
    }

    return (
        <div>
            <Tabs
                className="fullwidth klassSubTab"
                activeKey={activeKey}
                onChange={onChangeTab}
                tabBarStyle={isSidebarChat ? {margin: "6px 6px 2px 6px"} : {}}>
                {map(topics, (topic) => (
                    <Tabs.TabPane
                        key={topic.roomId}
                        className={cx(styles.tabContainer, {
                            [styles.reduceHeight]: isOnlyMessageCreation,
                            [styles.sidebarContainer]: isSidebarChat
                        })}
                        tab={<TabHeader title={topic.name} />}>
                        <div
                            className={cx(styles.composeContainer, {
                                [styles.sidebarComposeContainer]: isSidebarChat
                            })}>
                            <TopicDetails topic={topic} composeClassName={styles.composeContainer} canWrite={true} />
                        </div>
                    </Tabs.TabPane>
                ))}
            </Tabs>
            <BaseLoading isShow={isTopicsLoading} />
        </div>
    )
}
